<div class="field-link fx-layout-row fx-justify-start fx-align-baseline fx-gap-5">
  <mat-icon fontSet="mdi" fontIcon="mdi-plus-box-outline" class="xxs"></mat-icon>
  <span class="message" tabindex="0">{{ inputMessage }}</span>
</div>
